<template>
    <div class="item_sidebar">
        <div class="title title_m_b">{{title}}:</div>
        <div class="wrapper_input">
            <input type="text" :placeholder="'Enter ' + title" v-model="inputValue" ref="textInput">
            <a @click="inputChanged" class="button-wrapper popup_image_btn">
                <span class="label" style="white-space: nowrap;">Add video</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VideoUrlInput',
    props: ["value", "title"],
    data: function(){
        return {
            inputValue: ''
        }
    },
    methods: {
        inputChanged(){
            this.$emit('updated', this.inputValue);
            this.inputValue = '';
        },
    },
}
</script>